module.exports = {
  centra: ["Centra", "DM Sans", "sans-serif", "system-ui"],
  sans: ["DM Sans", "sans-serif", "system-ui"],
  sansbold: ["DM Sans Bold", "sans-serif", "system-ui"],
  serif: ["Recife", "Georgia", "serif"],
  recife: ["Recife", "Georgia", "serif"],
};
